var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counts && _vm.counts.locationUnreadCount)?_c('div',{staticClass:"-mr-1 px-2 py-1 bg-primary-600 text-white rounded-lg text-xs"},[_vm._v("\n  "+_vm._s(Number(_vm.counts.locationUnreadCount))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }